<template>
  <transition name="image-zoom-modal">
    <div
      v-if="isVisible"
      :class="{ 'is-active' : isVisible }"
      class="modal"
    >
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-content image-zoom-modal__content">
        <div class="box" style="height: 100%">
          <div class="columns is-mobile is-multiline" style="height: 95%">
            <div class="column is-narrow has-border-bottom pb-1">
              <span class="is-size-4 has-text-weight-medium">
                {{ $t('zoomImageModal.title') }}
              </span>
              <button v-if="loadingFullSize" class="button is-white is-loading"></button>
              <span v-if="loadingFullSize" class="is-size-6">
                {{ $t('zoomImageModal.loadingFullImage') }}
              </span>
            </div>
            <div class="column is-narrow has-border-bottom pb-1">
              <div v-if="!loadingFullSize" class="buttons are-small has-addons">
                <button
                  v-for="level in availableZoomRatios"
                  :key="level"
                  class="button"
                  :class="{ 'is-info': (level == zoomRatioLevel) }"
                  @click="( zoomRatioLevel = level )"
                >
                  {{ $t(`zoomImageModal.zoomLevels.${level}`) }}
                </button>
              </div>
            </div>
            <div class="column has-border-bottom pb-1">
              <button v-if="mediumResource" class="button is-small" @click="onDownloadImageClick">
                <span class="icon is-small">
                  <fa-icon :icon="['fas', 'cloud-download-alt']" />
                </span>
                <span>
                  {{ $t('zoomImageModal.downloadImageButton') }}
                </span>
              </button>
            </div>
            <div class="column is-narrow has-border-bottom pb-1">
              <button class="delete" @click="closeModal"></button>
            </div>
            <div class="column is-full image-zoom-modal__img-wrapper">
              <auth-image
                :src="imageSrc"
                :child-class="`image-zoom-modal__image zoom-${zoomRatioLevel}`"
                @loaded="onImageLoaded"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex'
const AuthImage = () => import('@/components/commons/AuthImage/Single.vue')

export default {
  name: 'ImageZoomModal',
  components: { AuthImage },
  data: () => ({
    imageSrc: null,
    loadingFullSize: false,
    zoomRatioLevel: 1,
    availableZoomRatios: 3
  }),
  computed: {
    ...mapGetters({
      isVisible: 'image_zoom_modal/isVisible',
      mediumId: 'image_zoom_modal/mediumId',
      fallbackSrc: 'image_zoom_modal/fallbackSrc',
      mediumResource: 'image_zoom_modal/mediumResource'
    }),
    imageFilename() {
      let filename = 'image'
      if (this.mediumResource) {
        filename = [
          this.mediumResource.advertorial.issue.name,
          this.mediumResource.advertorial.issue.country,
          this.mediumResource.advertorial.issue.pubblication_date
        ].join(' - ')
      }

      return `${filename}.png`
    }
  },
  watch: {
    'mediumId': {
      immediate: true,
      handler: function(newMediumId) {
        if (newMediumId) {
          this.fetchMediumSrc(newMediumId)
        }
      }
    }
  },
  methods: {
    fetchMediumSrc(mediumId) {
      this.loadingFullSize = true
      this.imageSrc = this.fallbackSrc
      this.$repositories()
          .media
          .getUrlById(mediumId, 'full_zoom')
          .then(imageUrl => ( this.imageSrc = imageUrl ))
    },
    onImageLoaded() {
      if (this.imageSrc === this.fallbackSrc) return

      this.loadingFullSize = false
    },
    closeModal() {
      this.imageSrc = null
      this.zoomRatioLevel = 1
      this.$store.dispatch('image_zoom_modal/closeZoom')
    },
    onDownloadImageClick() {
      fetch(this.imageSrc)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = this.imageFilename
        link.click()
      })
      .catch(console.error)
    }
  }
}
</script>
<style lang="scss">
.image-zoom-modal__content {
  width: 80% !important;
  height: 90%;
}

.image-zoom-modal__img-wrapper {
  height: 100%;
  overflow: scroll;
}

.image-zoom-modal__image {
  max-width: none;
  transition: width 0.2s ease;

  &.zoom-1 {
    width: 100%;
  }

  &.zoom-2 {
    width: 150%;
  }

  &.zoom-3 {
    width: 200%;
  }
}

@media only screen and (max-width: 767px) {
  .image-zoom-modal__content {
    width: 98% !important;
    height: 100vh;
    max-height: 100vh;
  }
}

.image-zoom-modal-enter-active, .image-zoom-modal-leave-active {
  transition: all 0.2s;
}
.image-zoom-modal-enter, .image-zoom-modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
